import('./setup-ing-web.js').then(() => {
  import('./init.js');
  import('./components/lptn/header.js');
  import('./components/lptn/main.js');
  import('./ing-app-authentication-main.js');
});
